module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_c('i', [_vm._v("Tenth Volume")])])]), _vm._v(" "), _c('p', {
    staticClass: "part-title"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EWEL AND")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EART OF")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-normal"
  }, [_vm._v("Always are there enemies. Some at you run with knife, some smile at your side. Some you notice not till round your throat their two hands come.")]), _vm._v(" "), _c('p', {
    staticClass: "part-right"
  }, [_vm._v("Inscription found on many male amulets;")]), _vm._v(" "), _c('p', {
    staticClass: "part-right1"
  }, [_vm._v("the warding spell is presumably carried")]), _vm._v(" "), _c('p', {
    staticClass: "part-right1"
  }, [_vm._v("by the stated facts: Vormlander")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 84
// module chunks = 0